import { Skeleton } from '@mui/material'

export default function CardLoader({ sx }: { sx?: any }) {
  return <Skeleton variant='rectangular' sx={sx} />
}
